export default __webpack_public_path__ + "static/media/white-button-active.7dd05e5f.png";